import { useState } from 'react';
import { useLocation } from 'wouter';
import {
  Drawer,
  DrawerContent,
} from '@/shared/components/ui/drawer';
import { ProductDrawerContent } from './product-drawer-content';
import { useProductDrawerModel } from './use-product-drawer-model';
import { Button } from '@/shared/components/ui/button';
import { ChevronDown } from 'lucide-react';

interface ProductDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  productId: string | null;
  slug: string;
}

export function ProductDrawer({ isOpen, onClose, productId, slug }: ProductDrawerProps) {
  // Estado interno para controlar a animação de saída do vaul
  const [internalOpen, setInternalOpen] = useState(true);
  const [, navigate] = useLocation();
  
  console.log('🎨 ProductDrawer renderizado:', {
    isOpen,
    internalOpen,
    productId,
    slug,
  });

  // Sincroniza internalOpen com isOpen quando o drawer é aberto novamente
  if (isOpen && !internalOpen) {
    setInternalOpen(true);
  }

  const handleCloseWithAnimation = () => {
    setInternalOpen(false); // Dispara a animação nativa do vaul
    
    // Verifica se veio do carrinho
    const urlParams = new URLSearchParams(window.location.search);
    const fromCart = urlParams.get('fromCart');
    const editItemId = urlParams.get('editItemId');
    
    if (fromCart === 'true' || editItemId) {
      console.log('🔙 Voltando para o carrinho');
      navigate('/cart/review-order');
    } else {
      onClose();
    }
  };

  const methods = useProductDrawerModel(productId, slug, handleCloseWithAnimation);

  // Não renderiza o drawer se não tem productId
  if (!productId) return null;

  return (
    <Drawer
      open={internalOpen}
      onOpenChange={(open) => {
        if (!open) {
          handleCloseWithAnimation();
        }
      }}
      dismissible={true}
      shouldScaleBackground={false}
    >
      <DrawerContent className="bg-transparent flex flex-col h-full data-[vaul-drawer-direction=top]:max-h-[98vh] data-[vaul-drawer-direction=bottom]:max-h-[98vh] !line border-none shadow-none rounded-t-[32px] outline-none">
        {/** Conteúdo do drawer */}
        <div className="w-full flex z-10 rounded-t-[32px] relative">
          <Button
            onClick={handleCloseWithAnimation}
            className="absolute top-4 left-4 z-10 cursor-pointer clickable-small bg-black/50 text-white hover:bg-black/70 h-10 w-10"
          >
            <ChevronDown className="text-white h-10 w-10 font-bold" />
          </Button>
        </div>
        <ProductDrawerContent {...methods} onCloseDrawer={handleCloseWithAnimation} />
      </DrawerContent>
    </Drawer>
  );
}
